import styled from "styled-components";

export const Component = styled.div<any>`
  color: #000 !important;
`;
